<h2 style="text-align: center;">Contact Us</h2>
<br />
<form id="contactForm" #form="ngForm" (ngSubmit)="sendContactForm(form)">
    <div class="row contact-wrap">
        <div class="col-sm-6 col-lg-6">
            <div class="form-group">
                <input #userName="ngModel" minlength="3" maxlength="30" type="text" name="userName" id="userName" ngModel class="form-control" required placeholder="Your Full Name">
                <span *ngIf="userName.errors?.minlength || userName.errors?.maxlength" class="custom-span">The name should be greater than atleast 2 characters</span>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6">
            <div class="form-group">
                <input  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"  #userEmail="ngModel" type="email" name="userEmail" id="userEmail" ngModel class="form-control" required placeholder="Your Email">
                <span *ngIf="userEmail.errors?.pattern" class="custom-span">The entered email is invalid</span>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6">
            <div class="form-group">
                <input pattern="^[0-9]{10,14}$" #userPhone="ngModel" type="number" name="userPhone" ngModel id="userPhone" required class="form-control" placeholder="Your Phone">
                <span *ngIf="userPhone.errors?.pattern" class="custom-span">The number should be of atleast 10 characters</span>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6">
            <div class="form-group">
                <input #userSubject="ngModel" minlength="10" maxlength="30" type="text" name="userSubject" ngModel id="userSubject" class="form-control" required placeholder="Subject">
                <span *ngIf="userSubject.errors?.minlength || userSubject.errors?.maxlength" class="custom-span">The subject must be greater than 10 and less than 30 characters</span>
            </div>
        </div>

        <div class="col-md-12 col-lg-12">
            <div class="form-group">
                <textarea #caseDescription="ngModel" minlength="50" maxlength="200" name="caseDescription" class="form-control" ngModel id="caseDescription" cols="30" rows="8" required placeholder="Case Description"></textarea>
                <span *ngIf="caseDescription.errors?.minlength || caseDescription.errors?.maxlength" class="custom-span">The details must be greater than 50 and less than 200 characters</span>
            </div>
        </div>

        <div class="col-md-12 col-lg-12">
            <div class="text-center">
                <button type="submit" [disabled]="form.invalid" class="contact-btn">Submit Case</button>
            </div>
        </div>
    </div>
    <br />
    <div class="text-center" *ngIf="isLoading">
        <div class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</form>